import { useQuery } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ProductTypes } from '@/types';

export const getProducts = (): Promise<ProductTypes[] | null> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'product';
  return axios
    .get(endPoint, {
      params: { isPublic: true },
    })
    .then((response: any) => {
      return response._embedded?.product;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

type QueryFnType = typeof getProducts;

type UseProductsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useProducts = ({ config = {} }: UseProductsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getProducts(),
    ...config,
  });
};
